import { Container, interfaces as inversifyInterfaces } from 'inversify';
import { makeFluentProvideDecorator, makeProvideDecorator } from 'inversify-binding-decorators';
import getDecorators from 'inversify-inject-decorators';
import "reflect-metadata";

export const inversifyContainer = new Container();
export const {lazyInject, lazyInjectNamed, lazyInjectTagged, lazyMultiInject} = getDecorators(inversifyContainer);

export const provide = makeProvideDecorator(inversifyContainer);
export const fluentProvide = makeFluentProvideDecorator(inversifyContainer);
export const provideSingleton = (identifier: inversifyInterfaces.ServiceIdentifier<any>) => {
  return fluentProvide(identifier)
    .inSingletonScope()
    .done();
};


// WEBPACK FOOTER //
// ./src/inversify.ts